// CandidateReceiptDetails_new.jsx (the post-login wizard's Receipt step, generated after a successful
// payment). Only the page chrome (pageHeading, printDownloadButton) was migrated in Phase C.5.
//
// Phase R6.6 (Candidate Receipt PDF Filename & Language Configuration Fix): the printable receipt
// payload (#outerBorder/#divReceiptPrint, rasterized by html2canvas/jspdf in onPrint) was previously
// hardcoded bilingual JSX — completely bypassing the Admin-configured PortalLanguage setting, meaning
// the downloaded PDF always showed Marathi even when English Only was configured. This reproduces, for
// the Candidate Receipt, the exact fix Phase R6.5 already applied to the Application Receipt
// (PreviewCandidateDetails_new.jsx / modules/i18n/pages/preview.js) — every entry below is wired through
// <Text k="receiptDetails.*"/> so this receipt follows the same authoritative language source as the
// rest of the candidate journey, instead of a second, parallel mechanism.
//
// Every entry is an EXTRACTION of text that was already bilingual in the JSX (zero new translation
// authored). Sub-fields that were already English-only in the original JSX (Village/City, Taluka, Dist,
// Pin Code, State, Mobile No., Email Id, Driving Licence No.) are left as-is — no new translation
// invented for content that never had one.
export default {
  pageHeading: { en: 'Candidate Receipt', mr: 'उमेदवाराची पावती' },
  printDownloadButton: {
    en: 'Print / Download Receipt',
    mr: 'पावती प्रिंट करा / डाउनलोड करा'
  },

  formNoLabel: { en: 'Form No', mr: 'फॉर्म क्रमांक' },
  appliedPostLabel: { en: 'Applied Post', mr: 'पदा साठी अर्ज केला' },
  transactionIdLabel: { en: 'Transaction ID', mr: 'व्यवहार आयडी' },
  feesLabel: { en: 'Fees', mr: 'शुल्क' },
  gstLabel: { en: 'GST', mr: 'जी.एस.टी' },

  fullNameLabel: { en: 'Full Name', mr: 'पूर्ण नाव' },
  fathersNameLabel: { en: "Father's Name", mr: 'वडिलांचे नाव' },
  mothersNameLabel: { en: "Mother's Name", mr: 'आईचे नाव' },
  aadhaarNoLabel: { en: 'Aadhaar No.', mr: 'आधार क्र.' },
  addressContactInfoLabel: { en: 'Address & Contact Info', mr: 'पत्ता आणि संपर्क माहिती' },
  genderLabel: { en: 'Gender', mr: 'लिंग' },
  dateOfBirthLabel: { en: 'Date Of Birth', mr: 'जन्मतारीख' },
  maritalStatusLabel: { en: 'Marital Status', mr: 'वैवाहिक स्थिती' },
  disabilityCategoryNameLabel: { en: 'Disability Category Name', mr: 'अपंगत्व श्रेणीचे नाव' },
  isScribeRequiredLabel: { en: 'Is Scribe Required?', mr: 'लेखनिक आवश्यक आहे का?' },
  existingEmployeeLabel: { en: 'Existing Employee', mr: 'विद्यमान कर्मचारी' },

  qualifyingExaminationLabel: { en: 'Qualifying Examination', mr: 'पात्रता परीक्षा' },
  educationColumnHeader: { en: 'Education', mr: 'शिक्षण' },
  specialisationColumnHeader: { en: 'Specialisation', mr: 'विशेषज्ञता' },
  boardUniversityColumnHeader: { en: 'Name of Board/University', mr: 'बोर्ड/विद्यापीठ/संस्थेचे नाव' },
  yearOfPassingColumnHeader: { en: 'Year Of Passing', mr: 'उत्तीर्ण वर्ष' },
  marksPercentColumnHeader: { en: 'Marks (%)', mr: 'ग्रेड/टक्के' },
  classColumnHeader: { en: 'Class', mr: 'वर्ग' },

  typingSkillHeading: { en: 'Other Skill details (Typing)', mr: 'इतर कौशल्य तपशील (टायपिंग)' },
  marathiTyping30Label: { en: 'Marathi Typing (Speed 30)', mr: 'मराठी टायपिंग (वेग ३०)' },
  englishTyping40Label: { en: 'English Typing (Speed 40)', mr: 'इंग्रजी टायपिंग (वेग 40)' },
  shortHandHeading: { en: 'Short Hand Details', mr: 'लघुलेखन' },
  wpm100Label: { en: '100 Words/Minutes (Marathi/English)', mr: '100 शब्द/मिनिटे (मराठी/इंग्रजी)' },
  wpm120Label: { en: '120 Words/Minutes (Marathi/English)', mr: '120 शब्द/मिनिटे (मराठी/इंग्रजी)' },

  experienceDetailsLabel: { en: 'Experience Details', mr: 'अनुभव तपशील' },
  organizationNameColumnHeader: { en: 'Organization Name', mr: 'संस्थेचे नाव' },
  designationColumnHeader: { en: 'Designation', mr: 'पदनाम' },
  fromDateColumnHeader: { en: 'From Date', mr: 'या तारखेपासून' },
  toDateColumnHeader: { en: 'To Date', mr: 'या तारखेपर्यंत' },

  declarationText: {
    en: 'I hereby declare that information furnished above is true and correct in every respect and in case any information is found incorrect even partially the candidature shall be liable to be rejected.',
    mr: 'मी याद्वारे घोषित करतो/करते की वर दिलेली माहिती प्रत्येक बाबतीत खरी आणि बरोबर आहे आणि कोणतीही माहिती अंशतः चुकीची आढळल्यास उमेदवारी नाकारली जाईल.'
  },
  placeLabel: { en: 'Place', mr: 'ठिकाण' },
  dateLabel: { en: 'Date', mr: 'तारीख' }
};
